import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from '@axios'

import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import { canNavigate } from '@/libs/acl/routeProtection'
import apps from './routes/apps'
import profileSettings from './routes/account-settins'
import auths from './routes/auth'
import others from './routes/others'
import usuario from './routes/usuario'
import grupousuario from './routes/grupousuario'
import tabelaPrecos from './routes/tabela-preco'
import categories from './routes/categories'
import clientes from './routes/clientes'
import produtos from './routes/produtos'
import fuciomalidadesMenus from './routes/fucionalidades_menus'
import abilities from './routes/ability'
import pedidos from './routes/pedidos'
import banners from './routes/banners'
import financial from './routes/financial'
import chatSuporte from './routes/chat-suporte'
import correios from './routes/correios'
import minhaLoja from './routes/minha-loja'
import settingRoutes from '@/views/apps/settings/router'
import planos from './routes/planos'
import blog from './routes/blog'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '', redirect: { name: 'app-deashboard' } },
    ...tabelaPrecos,
    ...usuario,
    ...produtos,
    ...grupousuario,
    ...categories,
    ...fuciomalidadesMenus,
    ...apps,
    ...profileSettings,
    ...auths,
    ...financial,
    ...others,
    ...clientes,
    ...abilities,
    ...pedidos,
    ...banners,
    ...settingRoutes,
    ...chatSuporte,
    ...correios,
    ...minhaLoja,
    ...planos,
    ...blog,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach(async (to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    return next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  if (to.meta.requiresWhiteLabel) {
    try {
      const { data } = await axios.get('/planos/assinaturas/whitelabel-check')
      if (!data?.tem_acesso) {
        return next({ name: 'app-minha-loja' })
      }
    } catch {
      return next({ name: 'app-minha-loja' })
    }
  }

  return next()
})

// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
